import { render, staticRenderFns } from "./pie-jps.vue?vue&type=template&id=99970a52&scoped=true&"
import script from "./pie-jps.vue?vue&type=script&lang=js&"
export * from "./pie-jps.vue?vue&type=script&lang=js&"
import style0 from "./pie-jps.vue?vue&type=style&index=0&id=99970a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99970a52",
  null
  
)

export default component.exports